export default __webpack_public_path__ + "static/media/ph_logo.5298e5ae.png";